//// Shared .Net DTO contracts. Declarations identical across apps live here;
//// app-specific variants stay in each app's data.models.ts / data.enums.ts.

//// BadgeRequestTypeEnum
export enum BadgeRequestTypeEnum {
    Default= 1,
    MissingPhoto= 2,
    Resubmission= 3
}

//// ColumnFilterTypeEnum
export enum ColumnFilterTypeEnum {
    None= 0,
    General= 1,
    Tag= 2,
    DateTimeRange= 3,
    Text= 4
}

//// CroppEngine
export enum CroppEngine {
    Draw= 0,
    Magick= 1,
    SixLabors= 2,
    ImageProcessor= 3
}

//// DocumentTypeEnum
export enum DocumentTypeEnum {
    Passport= 1,
    FrontFace= 2,
    Signature= 3,
    Attachment= 4
}

//// MemberFirmVisitorVisaTypeEnum
export enum MemberFirmVisitorVisaTypeEnum {
    Business= 1,
    EBusiness= 2,
    ETourist= 3,
    Employment= 4,
    Resident= 5,
    Tourist= 6
}

//// MemberFirmVisitorVisitReasonEnum
export enum MemberFirmVisitorVisitReasonEnum {
    DeliverAttendInternalTrainings= 1,
    ExternalClientMeetings= 2,
    InternalTeamMeetings= 3,
    ParticipateInExternalTrainings= 4,
    PerformClientBillableWork= 5,
    SeminarsOrConferences= 6,
    SupervisingClientBillableWork= 7
}

//// MobileBadgeStatusEnum
export enum MobileBadgeStatusEnum {
    Pending= 1,
    Approved= 2,
    Provisioned= 3,
    Canceled= 4
}

//// MobileDeviceStatusEnum
export enum MobileDeviceStatusEnum {
    NotPushed= 1,
    Pushing= 2,
    Pushed= 3
}

//// MobileRequestReasonEnum
export enum MobileRequestReasonEnum {
    InitialBadge= 1,
    LostPhone= 2,
    WeeklyTraveler= 3
}

//// NonDeloittePurposeOfVisitEnum
export enum NonDeloittePurposeOfVisitEnum {
    AuditAssessment= 1,
    BusinessVisit= 2
}

//// NonDeloitteTypeOfVisitEnum
export enum NonDeloitteTypeOfVisitEnum {
    Client= 1,
    GovernmentOfficial= 2,
    Trainer= 3,
    Others= 4
}

//// NotificationTypeEnum
export enum NotificationTypeEnum {
    PrehirePhotoUpload= 1,
    PrehireOutOfCompliance= 3,
    PrehireBadgePickUp= 4,
    EmployeeOutOfCompliance= 5,
    EmployeeBadgePickUp= 6,
    PrehireWelcome= 7,
    MissingPhoto= 8,
    BadgeStolenDamagedLost= 9,
    VisitorBadgeCreated= 10,
    VisitorBadgeReadyForApprove= 11,
    VisitorBadgeDeclined= 12,
    VisitorBadgePickUp= 13,
    BadgeDeclined= 14,
    BadgeDeactivated= 15
}

//// OldAccessCardDeactivatedEnum
export enum OldAccessCardDeactivatedEnum {
    Yes= 1,
    No= 2
}

//// PeoplePickerPhoneTypeEnum
export enum PeoplePickerPhoneTypeEnum {
    OfficePhone= 2,
    MobilePhone= 8
}

//// PersonaTypeEnum
export enum PersonaTypeEnum {
    MemberFirm= 1,
    NonDeloitte= 2,
    ThirdPartyContractor= 3
}

//// ReIssueBadgeReasonEnum
export enum ReIssueBadgeReasonEnum {
    Damaged= 1,
    Lost= 2,
    Stolen= 3
}

//// RejectedPhotoReasonEnum
export enum RejectedPhotoReasonEnum {
    PhotoIsPixelatedOrBlurry= 1,
    PhotoIsTooLarge= 2,
    PhotoIsTooSmall= 3,
    FacialExpressionInappropriateOrEyesClosed= 5,
    PhotoshoppedFilteredPhotoOrPhotoIsTooDark= 6,
    SunglassesOrHatOnIndividual= 7,
    NotFacingForward= 8,
    PhotoIsBlackAndWhite= 9,
    PhotoTakenInLandscapePerspective= 10,
    BackgroundInappropriateIncorrect= 11,
    PhotoIsNotOfIndividual= 12
}

//// SaveEmployeeActionEnum
export enum SaveEmployeeActionEnum {
    Add= 1,
    Save= 2
}
